// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notice[data-v-3a4f2e1b] {\n  background: #fffbe5;\n}", ""]);
// Exports
module.exports = exports;
